export const MEMBERSHIPS = {
  CLASSIC: 'classic',
  CLASSIC_PAYG_ONLY: 'classic-payg-only',
  BASIC: 'basic'
}

export const MEMBERSHIPS_READABLE = {
  [MEMBERSHIPS.CLASSIC]: 'Classic',
  [MEMBERSHIPS.CLASSIC_PAYG_ONLY]: 'Managed Credit',
  [MEMBERSHIPS.BASIC]: 'Basic'
}
